import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function BackSpineCare() {
  useEffect(() => {
    document.title = "Back & Spine Care | Viksha Health Care";
    const newMetaDescription =
      "Back and spine care at Viksha Health Care. Diagnosis of back pain, disc issues, and posture-related problems with a structured care plan.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Back & Spine Care</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Back-Spine-Care.avif" />
        </div>
        <div className="textareaofser">
          <h1>Back & Spine Care</h1>

          <p>
            Back and spine problems can cause pain, stiffness, and difficulty
            with everyday activities. Proper evaluation and timely care can help
            relieve discomfort, improve mobility, and prevent long-term
            complications.
          </p>

          <p>
            The spine supports the body, protects the spinal cord, and allows
            movement. Conditions affecting the spine can range from muscle
            strain to disc-related issues and age-related changes.
          </p>

          <h5>Common Spine and Back Problems</h5>
          <ul>
            <li>Neck pain and stiffness</li>
            <li>Low back pain</li>
            <li>Disc-related conditions</li>
            <li>Muscle and ligament strain</li>
            <li>Posture-related back pain</li>
            <li>Sciatica and nerve-related pain</li>
          </ul>

          <h5>Evaluation and Diagnosis</h5>
          <p>
            A detailed clinical examination helps identify the source of back or
            spine pain. In some cases, imaging tests may be advised to better
            understand the underlying cause.
          </p>

          <h5>Non-Surgical Treatment Options</h5>
          <ul>
            <li>Medications for pain and inflammation relief</li>
            <li>Physiotherapy and posture correction exercises</li>
            <li>Lifestyle and ergonomic advice</li>
            <li>Strengthening and flexibility programs</li>
          </ul>

          <h5>When Advanced Treatment May Be Needed</h5>
          <p>
            If symptoms do not improve with conservative treatment or if there
            is significant nerve compression, further procedures may be
            discussed.
          </p>

          <h5>Importance of Rehabilitation</h5>
          <p>
            Rehabilitation focuses on improving core strength, posture, and
            flexibility, which helps reduce pain and prevent future spine
            problems.
          </p>

          <h5>When to Seek Spine Care</h5>
          <ul>
            <li>Persistent back or neck pain</li>
            <li>Pain radiating to arms or legs</li>
            <li>Numbness or tingling sensations</li>
            <li>Weakness in limbs</li>
            <li>Difficulty standing or walking</li>
          </ul>

          <p>
            Early spine care can help manage pain effectively and support a
            return to normal daily activities with better comfort and mobility.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(BackSpineCare);
